import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserClaim, UserProfile } from '@modules/auth/models';

@Injectable()
export class AuthContext {
    claims: UserClaim[] = [];
    userProfile: UserProfile | undefined;

    get isAdmin() {
        return !!this.claims && !!this.claims.find((c) => c.type === 'role' && c.value === 'Admin');
    }

    get domain(): string | null {
        const claim = this.claims.find((c) => c.type === 'domain');
        return claim?.value ?? null;
    }
}
